import {Address, Gender} from "./weak-entities";

export interface Patient {
  Id:string;
  VisitStamp:Date;
  PracticeId:string;
  FirstName:string;
  LastName:string;
  Email:string;
  PhoneNumber:string;
  Address:Address;
  Gender:Gender;
  Height:number;
  Weight:number;
  BirthDay:Date;
  Goal:string;
  Notes:string;
  AuthorizedEmails:string;
}
export function getAge(birthday: Date): number {
  let bDate: Date = new Date(birthday);
  let timeDiff: number = Math.abs(Date.now() - bDate.getTime());
  let age: number = Math.floor((timeDiff/ (1000 * 3600 * 24))/365.25);
  return age;
}
export function newPatient(): Patient {
  return {
    Id: '',
    VisitStamp: new Date(),
    PracticeId: '',
    FirstName: '',
    LastName: '',
    Email: '',
    PhoneNumber: '',
    Address: {
      Line1: '',
      Line2: '',
      Line3: '',
      City: '',
      StateProvinceCounty: '',
      ZipOrPostcode: '',
      Country: '',
      Other: ''
    },
    Gender: Gender.Male,
    Height: 0,
    Weight: 0,
    BirthDay: new Date(),
    Goal: '',
    Notes: '',
    AuthorizedEmails: '',
  }
}



// WEBPACK FOOTER //
// ./src/model/patient.ts